export default [
  {
    path: 'subscription/order',
    name: 'Subscription Order List',
    component: () => import('@/views/subscription/order/list/index.vue'),
    meta: {
      icon: 'icon-dingyue-guanli',
      resourceCode: 'subscription:order',
    },
  },
  {
    path: 'subscription/order/detail',
    name: 'Subscription Detail',
    component: () => import('@/views/subscription/order/detail/index.vue'),
    meta: {
      activeMenu: '/subscription/order',
      name: 'message.subscription.details',
      resourceCode: 'subscription:detail',
    },
  },
  {
    path: 'subscription/setting',
    name: 'Subscription setting',
    component: () => import('@/views/subscription/setting/index.vue'),
    meta: {
      activeMenu: '/subscription/setting',
      name: 'message.subscription.setting',
      resourceCode: 'subscription:setting',
    },
  },
];
